export default __webpack_public_path__ + "static/jumbo-m1-img-3de9db92b38d0c9a5fe05d597d0f3ace.png";